(function() {
  function initTestimonialStrip() {
    const splideCssUrl = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css';
    const splideJsUrl = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';

    // 1. Dynamically Inject CSS (Restored to working version)
    if (!document.querySelector(`link[href*="splide.min.css"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = splideCssUrl;
      document.head.appendChild(link);
    }

    // 2. Dynamically Inject JS 
    if (!document.querySelector(`script[src*="splide.min.js"]`)) {
      const script = document.createElement('script');
      script.src = splideJsUrl;
      script.defer = true;
      document.head.appendChild(script);
    }

    // 3. Poll for Splide and Mount
    const initSplide = setInterval(() => {
      if (typeof Splide !== 'undefined') {
        clearInterval(initSplide); 
        
        const strips = document.querySelectorAll('.js-testimonial-strip');
        
        strips.forEach(el => {
          // Use a custom data attribute to prevent double-mounting safely
          if (el.dataset.mounted === 'true') return;
          
          new Splide(el, {
            type         : 'loop',    
            perPage      : 1,         
            arrows       : false,     
            pagination   : false,      
            drag         : true,
            autoplay     : true,      
            interval     : 4000,      
            pauseOnHover : true,     
            pauseOnFocus : true
          }).mount();

          // Flag as successfully mounted
          el.dataset.mounted = 'true';
        });
      }
    }, 100);
  }

  // 4. Bulletproof Load Checker
  // Guarantees execution whether the page is still loading or already done
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestimonialStrip);
  } else {
    initTestimonialStrip();
  }
})();